import { Spinner } from '@blueprintjs/core'
import React from 'react'

export const LoadingComponent = ({ size = undefined }: { size?: number }) => {
    if (!size) {
        size = 50
    }

    return (
        <div className="flex w-full h-full justify-center items-center">
            <Spinner size={size} intent="primary" />
        </div>
    )
}
